import { ActionReducerMap, createFeatureSelector } from '@ngrx/store'

import { FolderOverviewFeatureState } from '../models'
import { featureKey } from '../const'
import { folderOverviewReducer } from './folder-overview.reducer'
import { folderScopesReducer } from './folder-scopes.reducer'

export const folderOverviewReducers: ActionReducerMap<FolderOverviewFeatureState> = {
  folderScopes: folderScopesReducer,
  folderOverview: folderOverviewReducer,
}

export const getFolderOverviewFeatureState = createFeatureSelector<FolderOverviewFeatureState>(featureKey)
